import { registerLanguage } from '../_.contribution.js';

registerLanguage({
  id: "sql",
  extensions: [".sql"],
  aliases: ["SQL"],
  loader: () => import('./sql.js')
});
